<template>
    <router-link class="block mx-2" :to="link">
        <img src="/icons/actions/see.svg" class="h-4 w-4 opacity-50 hover:opacity-100" />
    </router-link>
</template>

<script>
    export default {
        props: ['link']
    }
</script>